import { type ManagedBy } from 'core/domain/ManagedBy'

import { type Shipper } from '../domain/Shipper'

export type ContactData = {
  email: string
  name: string
  phone: string
}

export function formatContact(shipper: Shipper, managedBy?: ManagedBy): ContactData {
  return {
    email: managedBy?.contactEmail || shipper.email || '',
    name: managedBy?.contactName || shipper.name || '',
    phone: managedBy?.contactPhone || shipper.phoneNumber || '',
  }
}
